// extracted by mini-css-extract-plugin
module.exports = {"photo":"idt-photoprintframe_photo__2whgh","draggable":"idt-photoprintframe_draggable__2x3ay","accessoryDragOver":"idt-photoprintframe_accessorydragover__3y53-"};